const ProblemAreaPreview = (props) => {
    let { FrontBodyDiagram, BackBodyDiagram} = {...props};
    const allMarkersSorted = [...(FrontBodyDiagram || []), ...(BackBodyDiagram || [])]
        .sort((a, b) => Number(a.markerId) - Number(b.markerId));
    
  let noValExistText = <p className="text ar-light-color">No data recorded</p>;
    return (
        <>
            <div className="ar_problem-area-print-view ar_body-Comment-design w-100">
                <div className="d-flex gap-20">
                    <div style={{ position: "relative" }}>
                        <img
                            src={process.env.PUBLIC_URL + ("/assets/images/body-front.png")}
                            alt="body"
                            height={265}
                        />
                        {/* Markers */}
                        {(FrontBodyDiagram || []).map(marker => (
                            <div
                                key={`FrontBodyDiagram-${marker.markerId}`}
                                style={{
                                    position: "absolute",
                                    left: `${marker.x}%`,
                                    top: `${marker.y}%`,
                                    transform: "translate(-50%, -50%)",
                                }}
                                className='ar-marker d-flex align-items-center justify-content-center'
                            >
                                <p className='mark-number font-m text-white text lh-12 d-flex align-items-center justify-content-center'>{marker?.markerId}</p>
                            </div>
                        ))}
                    </div>
                    <div style={{ position: "relative" }}>
                        <img
                            src={process.env.PUBLIC_URL + ("/assets/images/body-back.png")}
                            alt="body"
                            height={265}
                        />
                        {/* Markers */}
                        {(BackBodyDiagram || []).map(marker => (
                            <div
                                key={`BackBodyDiagram-${marker.markerId}`}
                                style={{
                                    position: "absolute",
                                    left: `${marker.x}%`,
                                    top: `${marker.y}%`,
                                    transform: "translate(-50%, -50%)",
                                }}
                                className='ar-marker d-flex align-items-center justify-content-center'
                            >
                                <p className='mark-number font-m text-white text lh-12 d-flex align-items-center justify-content-center'>{marker?.markerId}</p>
                            </div>
                        ))}
                    </div>
                    <div className='w-100'>
                        <p className="heading fs-13 text-decoration-underline mb-1">Problem Notes</p>
                        <div className="problem-note-content d-flex flex-column gap-2 w-100">
                            {allMarkersSorted?.length > 0 ? (
                                <>
                                    {allMarkersSorted.map(mark => (
                                        <div key={`note-${mark.markerId}`} className='d-flex align-items-center gap-1'>
                                            <p className="ar-mark d-flex align-items-center justify-content-center heading text-white fs-10">{mark?.markerId}</p>
                                            <p className="text">{mark?.comment}</p>
                                        </div>
                                    ))}
                                </>
                            ) : noValExistText}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProblemAreaPreview;
